module.exports = __webpack_public_path__ + "static/media/轉所申請書中英文版20230413.191700de.pdf";